/**
 * The message an Edge Function sent with a non-2xx reply. supabase-js
 * reports those as a generic FunctionsHttpError and keeps the reply in
 * `context`; the function's own words ("A test goes to one email
 * address.") are more use to the person than "non-2xx status code".
 * Null when there was no reply at all (not deployed, offline).
 */
export async function functionError(error: unknown): Promise<string | null> {
  const ctx = (error as { context?: unknown } | null)?.context;
  if (!(ctx instanceof Response)) return null;
  try {
    const body = await ctx.clone().json() as { error?: string };
    return body?.error ?? `The mail function replied ${ctx.status}.`;
  } catch {
    return `The mail function replied ${ctx.status}.`;
  }
}
